import { connect } from 'react-redux';
import { goalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import MobileRetirementView from '../../MobileFinancialPlan/MobileRetirement/MobileRetirementView';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import { getGoal } from '../FinancialPlanHelpers';
import { calibration as calibrationSelector, data as dataSelector } from '../FinancialPlanSelector';
import {
  getSelectedGoalChart,
  hasChartSelector,
  printTitleSelector,
  retirementAssumptionsSelector,
  selectedSectionSelector,
} from './RetirementSelector';
import View from './RetirementView';
import { RETIREMENT_GOAL_TYPE } from './RetirementConstants';

const mapStateToProps = (state, ownProps) => {
  const data = dataSelector(state, ownProps);
  const goal = ownProps.goal || getGoal(data, goalId(state, ownProps));
  const selectedSection = ownProps.selectedSection || selectedSectionSelector(state, ownProps);

  let retirementGoal;

  if (goal.GoalType === RETIREMENT_GOAL_TYPE) {
    retirementGoal = goal;
  }

  return {
    retirementGoal,
    calibration: calibrationSelector(state, ownProps),
    goalId: goal.GoalId,
    selectedSection,
    printTitle: ownProps.printTitle || printTitleSelector(state, ownProps),
    data,
    isCurrentPlan: isCurrentPlanSelector(state, ownProps),
    retirementAssumptions: retirementAssumptionsSelector(state, ownProps),
    hasChart: hasChartSelector(selectedSection, goal),
    selectedGoalChart: getSelectedGoalChart(selectedSection, goal),
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

export const MobileRetirement = connect(mapStateToProps, mapDispatchToProps)(MobileRetirementView);
